module.exports = __webpack_public_path__ + "static/media/integration-build.1c42d51f.jpg";